import Vue from 'vue'
import { clone } from 'ramda'
import equal from 'fast-deep-equal'
import {userService} from "@/services/user.service";
import {thingService} from "@/services/thing.service";

export default {
    name: 'EquipmentTabComponent',
    components: {},
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        enterpriseId: '',
        // model para el formulario
        isValidForm: false,
        // search del treeview
        search: null,
        // elementos seleccionados
        selected: [],
        // últimos elementos seleccionados clonados (para evitar recursividad infinita en la función selectedChanged)
        lastSelectedCloned: null,
        // cuando se ejecuta la validación de elementos seleccionados, activo un spinner
        loading: false
    }),
    computed: {},
    created() {
    },
    mounted() {
        this.initialize();
    },
    methods: {
        /**
         * Obtiene la estructura anidada de empresas -> grupos -> equipos
         */
        initialize() {
            // expando el treeview
            Vue.nextTick(() => this.expandCollapse(true));
        },
        async getEquipmentsData(enterpriseId) {
            const user = await userService.getUser(localStorage.getItem('userId'));
            this.model.data = await thingService.getThingsNestedInEnterprises(
                [enterpriseId], [enterpriseId, ...user.userGroups, ...user.userThings], user._id);
        },
        /**
         * Expande / colapsa el árbol
         * @param {*} value
         */
        expandCollapse(value) {
            this.$refs.thingAssignmentTreeview.updateAll(value);
        },
        /**
         * Cuando cambian los nodos seleccionados, ejecuto una función para eliminar de la selección
         * otros nodos que no corresponden:
         * - Cuando selecciono un hijo, el padre no debe estar seleccionado;
         * - Cuando selecciono un padre, los hijos no deben estar seleccionados.
         * De esta forma, no hay datos redundantes, por ejemplo, que una empresa esté en el arreglo userEnterprises
         * y todas las cosas estén en el arreglo userThings
         */
        selectedChanged(nodes) {
            Vue.nextTick(() => {
                this.selected.cleanAndUpdate(nodes)
                this.model.validForm = !!this.selected.length;
                if (this.selected.length) {
                    this.model.selectedData.cleanAndUpdate(nodes);
                }
                // Se valida que haya cambiado el arreglo de elemento seleccionados, para evitar recursividad infinita
                if (this.lastSelectedCloned && !equal(this.lastSelectedCloned, this.selected)) {
                    this.loading = true;
                    // invierto el orden porque los elementos seleccionados más recientemente están en el final del arreglo
                    const selectedCloned = clone(this.selected);
                    this.lastSelectedCloned = selectedCloned;
                    const reverseSelected = selectedCloned.reverse();
                    // por cada elemento, verifico si hay que eliminar padres o hijos
                    let index;
                    let flag;
                    reverseSelected.forEach(element => {
                        switch (element.nodeType) {
                            case 'THING':
                                // empresa
                                if (!element.enterpriseId) {
                                    index = selectedCloned.findIndex(item => item.id === element.enterpriseId);
                                    if (index > -1) {
                                        selectedCloned.splice(index, 1);
                                    }
                                }
                                // grupo
                                if (!element.groupId) {
                                    index = selectedCloned.findIndex(item => item.id === element.groupId);
                                    if (index > -1) {
                                        selectedCloned.splice(index, 1);
                                    }
                                }
                                break;
                            case 'GROUP':
                                // empresa
                                if (!element.enterpriseId) {
                                    index = selectedCloned.findIndex(item => item.id === element.enterpriseId);
                                    if (index > -1) {
                                        selectedCloned.splice(index, 1);
                                    }
                                }
                                // cosas
                                flag = false
                                while (!flag) {
                                    index = selectedCloned.findIndex(item => item.groupId === element.id);
                                    if (index > -1) {
                                        selectedCloned.splice(index, 1);
                                    } else {
                                        flag = true;
                                    }
                                }
                                break;
                            case 'ENTERPRISE':
                                // grupos y cosas
                                flag = false
                                while (!flag) {
                                    index = selectedCloned.findIndex(item => item.enterpriseId === element.id);
                                    if (index > -1) {
                                        selectedCloned.splice(index, 1);
                                    } else {
                                        flag = true;
                                    }
                                }
                                break;
                            default:
                                console.error('Tipo de nodo de la lista de cosas anidadas en grupos y empresas desconocido');
                        }
                    })
                    this.selected = clone(selectedCloned);
                    this.loading = false;
                }

                this.model.result.cleanAndUpdate(this.selected);
            });
        }
    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('update:validForm', newVal);
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.userDialogThingAssignmentTabForm) {
                this.$refs.userDialogThingAssignmentTabForm.resetValidation();
            }
        },
        /**
         * Búsqueda en el treeview de equipos asignados
         * @param {*} newVal
         */
        search(newVal) {
            if (newVal) {
                this.$refs.thingAssignmentTreeview.updateAll(true);
            }
        },
        /*
         * No asigno directamente los objetos seleccionados, para controlar cuando se modifican
         * las empresas seleccionadas
         */
        'model.selectedData': {
            deep: true,
            immediate: true,
            handler: function (newSelectedData)  {
                this.selected = clone(newSelectedData);
                this.lastSelectedCloned = clone(this.selected);
            }
        },
        'model.enterpriseId': {
            deep: true,
            immediate: true,
            handler: function (newEnterpriseId)  {
                if (newEnterpriseId) {
                    this.loading = true;
                    this.isValidForm = false;
                    this.getEquipmentsData(newEnterpriseId).finally(() => this.loading = false);
                }
            }
        },
    }
}
